import { IStandardAutocomplete } from "../../_common/interface/autocomplete/iStandardAutocomplete";
import { racingClubService } from "../../_services/racingClub.service";
import StandardAutoComplete from "./standard.autocomplete";

interface IStandardExtAutocomplete extends IStandardAutocomplete {
}

export const RacingClubAutoComplete = (params: IStandardExtAutocomplete) => {

    return (
        <StandardAutoComplete
            {...params}
            itemsLoader={racingClubService.getDropdown}
            label={"Racing Club"} />
    );
}